module.exports = __webpack_public_path__ + "img/stat-card-3.156c5be4.png";